import Pagination from './pagination-TEMPLATE_VERSION'

export default Pagination
